const ACCORDION_ACTIVE_CLASS = 'active'

class StatisticsAccordion {
    constructor(element) {
        if (!element) return

        this.element = element

        this._iniAccordion()
    }

    _iniAccordion() {
        this.element.querySelectorAll('.b-statistics-accordion__head').forEach((head) => {
            head.addEventListener('click', (e) => {
                const accordionItem = e.currentTarget.parentNode
                const accordionBody = accordionItem.querySelector('.b-statistics-accordion__body')

                if (!accordionItem.classList.contains(ACCORDION_ACTIVE_CLASS)) {
                    accordionItem.classList.add(ACCORDION_ACTIVE_CLASS)
                    $(accordionBody).slideDown()
                } else {
                    accordionItem.classList.remove(ACCORDION_ACTIVE_CLASS)
                    $(accordionBody).slideUp()
                }
            })
        })
    }
}

export default StatisticsAccordion
